import { getSessionOrganizationId } from '../../shell/session/sessionOrganization';
import {
  brandsFromWebCacheOrNull,
  type BrandFilterState,
  type BrandRecord,
} from './brandsRepoShared';
export const countBrandsLocal = async (
  filterState: BrandFilterState = 'active',
  search?: string
): Promise<number> => {
  const org = await getSessionOrganizationId();
  if (!org) return 0;

  // ADR-017 Fase 4: SQLite local eliminado — leer de catalogRamSnapshotCache.
  const cached = brandsFromWebCacheOrNull(org, filterState, search);
  return cached !== null ? cached.length : 0;
};

export const listBrandsLocalPaged = async ({
  filterState = 'active',
  search,
  limit,
  offset = 0,
}: {
  filterState?: BrandFilterState;
  search?: string;
  limit?: number;
  offset?: number;
}): Promise<BrandRecord[]> => {
  const org = await getSessionOrganizationId();
  if (!org) return [];

  // ADR-017 Fase 4: SQLite local eliminado — leer de catalogRamSnapshotCache.
  return brandsFromWebCacheOrNull(org, filterState, search, limit, offset) ?? [];
};

export const listBrandsLocal = async (): Promise<BrandRecord[]> => {
  const org = await getSessionOrganizationId();
  if (!org) return [];
  // ADR-017 Fase 4: SQLite local eliminado — leer de catalogRamSnapshotCache.
  return brandsFromWebCacheOrNull(org, 'all') ?? [];
};

export const listActiveBrandsLocal = async (): Promise<Array<{ id: string; name: string }>> => {
  const org = await getSessionOrganizationId();
  if (!org) return [];

  const fromCache = brandsFromWebCacheOrNull(org, 'active');
  if (fromCache !== null) {
    return fromCache.map((brand) => ({ id: brand.id, name: brand.name }));
  }
  return [];
};
